/**
 * A place for global keyboard shortcuts
 */
namespace appn.shortcuts {
    /**
     * Appn wrapper for hotkeys
     * Fully cross browser supported
     * https://github.com/jaywcjlove/hotkeys/
     */
    export function init() {
        // This enables the use of hotkeys from within inputs as it is normally suppressed by the library
        // https://github.com/jeresig/jquery.hotkeys#hotkeys-within-inputs
        (window as any).hotkeys.filter = () => {
            return true;
        };

        // Register global appn shortcuts here
        (window as any).hotkeys('ctrl+s,ctrl+shift+d', function(event: Event, handler: any) {
            switch (handler.key) {
                // Ctrl+s Hits the save button in the navbar on each page.
                case 'ctrl+s': {
                    event.preventDefault();
                    $('.navbar-default button[value="Save"]').click();
                    break;
                }
                // Ctrl+Shift+d Opens and closes the Dev Widget.
                case 'ctrl+shift+d': {
                    event.preventDefault();
                    devWidget.widgetShortcut(event);
                    break;
                }
            }
        });
    }
}
